var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.5 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.25 9.004a.75.75 0 0 1-.532-.217l-7.5-7.5A.754.754 0 0 1 1.285.22L8.25 7.193 15.215.22a.753.753 0 0 1 1.065 1.065l-7.5 7.5a.75.75 0 0 1-.53.219"
  })));
};
export default SvgArrowDown;